import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const featuresSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-interactive-feature-content');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.gg-swiper-features');
    const swipersImg = module.querySelector('.gg-swiper-img');
    const swiperWrapper = module.querySelector('.gg-swiper-features-wrapper');
    const swiperSlides = module.querySelectorAll('.gg-swiper-features-slide');
    const imageLaptops = module.querySelectorAll('.gg-slide-image');

    if (!swipers || !swiperWrapper) {
      return;
    }
    swiperSlides.forEach((slide, index) => {
      slide.classList.add('fade-in-up', `delay-${index}`);
    });
    const swiperNext = module.querySelector('.gg-features-benefits__next-btn > a');
    const swiperPrev = module.querySelector('.gg-features-benefits__prev-btn > a');
    if (swiperPrev) {
      swiperPrev.setAttribute('rel', 'prev');
      swiperPrev.setAttribute('aria-label', 'prev button');
    }
    if (swiperNext) {
      swiperNext.setAttribute('rel', 'next');
      swiperNext.setAttribute('aria-label', 'next button');
    }
    
    if (window.innerWidth < 1380 && window.innerHeight < 1025) {


      swipers.classList.add('swiper-container');
      swiperWrapper.classList.add('swiper-wrapper');
      swiperSlides.forEach((slide, index) => {
        slide.classList.add('swiper-slide');
      });

      const carousel = new window.Swiper(swipers, {
        loop: false,
        centeredSlides: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        slidesPerGroup: 1,
        slidesPerView: 1,
        allowTouchMove: true,
        spaceBetween: 48,
        navigation: {
          prevEl: swiperPrev,
          nextEl: swiperNext,
        },
        on: {
          init: (swiper) => addSlidesTabIndex(swiper),
          slideChange: (swiper) => addSlidesTabIndex(swiper),
        },
      });

      let imgCarousel = null;

      if (swipersImg) {
        imgCarousel = new window.Swiper(swipersImg, {
          loop: false,
          centeredSlides: false,
          watchOverflow: true,
          watchSlidesProgress: true,
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          allowTouchMove: true,
          breakpoints: {
            1200: {
              slidesPerView: 'auto',
            },
            200: {
              slidesPerView: 1,
            },
          },
          on: {
            init: (swiper) => addSlidesTabIndex(swiper),
            slideChange: (swiper) => addSlidesTabIndex(swiper),
          },
        });
      }

      if (imgCarousel) {
        carousel.controller.control = imgCarousel;
        setTimeout(() => {
          carousel.init();
          imgCarousel.init();
        }, 300);
      }
    } else {
      imageLaptops.forEach((image, indexImage) => {
        const imageClassName = `img-slide-${indexImage}`;
        image.classList.add(imageClassName);
      });

      const defaultImageIndex = 0;
      let currentHoveredSlideIndex = null;

      function showDefaultImage() {
        const defaultImgClassName = `img-slide-${defaultImageIndex}`;
        const defaultImageSlide = module.querySelector(`.${defaultImgClassName}`);
        if (defaultImageSlide) {
          defaultImageSlide.style.opacity = 1;
        }

        imageLaptops.forEach((image, index) => {
          if (index !== defaultImageIndex) {
            const imgClassName = `img-slide-${index}`;
            const imageSlide = module.querySelector(`.${imgClassName}`);
            imageSlide.style.opacity = 0;
          }
        });
      }

      swiperSlides.forEach((slide, indexSlide) => {
        const slideClassName = `swiper-slide-${indexSlide}`;
        slide.classList.add(slideClassName);

        slide.addEventListener('mouseover', () => {
          currentHoveredSlideIndex = indexSlide;
          const imgClassName = `img-slide-${indexSlide}`;
          const imageSlide = module.querySelector(`.${imgClassName}`);
          if (imageSlide) {
            imageSlide.style.opacity = 1;
          }
        });

        slide.addEventListener('mouseout', () => {
          currentHoveredSlideIndex = null;
          showDefaultImage();
        });
      });

      showDefaultImage();
    }
  });
};

featuresSliderInit();
